import React                                                                                                                    from 'react';
import { PluginDocumentSettingPanel }                                                                                           from '@wordpress/edit-post';
import { TextareaControl, TextControl }                                                                           from '@wordpress/components';
import withMetaboxValidation                                                                                                    from './withMetaboxValidation';
import { OrderBumpsMeta, ValidationRules }                                                                                      from '../../Types/ValidationRules';
import {__} from "@wordpress/i18n";

const getValidationRules: ( meta: OrderBumpsMeta ) => ValidationRules = ( meta ) => ( {
    cfw_ob_offer_language: {
        required: true,
        error: 'Offer Language is a required field.',
    },
    cfw_ob_offer_description: {
        required: true,
        error: 'Offer Description is a required field.',
    },
} );

const OrderBumpsOfferLanguagePanel = ( { meta, handleFieldChange } ) => (
    <PluginDocumentSettingPanel
        name="cfw-ob-offer-language"
        title={__("Offer Language", 'checkout-wc' ) }
        className="cfw-ob-offer-language-mb"
    >

        {meta.cfw_ob_display_location === 'complete_order'
                && <>
                    <TextControl
                        label={__( 'Place Order Modal Heading', 'checkout-wc' )}
                        help={__( 'Default if blank: Your order is almost complete...', 'checkout-wc' )}
                        value={ meta.cfw_ob_offer_heading }
                        onChange={
                            ( newValue: string ) => {
                                handleFieldChange( 'cfw_ob_offer_heading', newValue );
                            }
                        }
                    />
                    <TextControl
                        label={__( 'Place Order Modal Subheading', 'checkout-wc' )}
                        help={__( 'Default if blank: Add this offer to your order and save!', 'checkout-wc' )}
                        value={ meta.cfw_ob_offer_subheading }
                        onChange={
                            ( newValue: string ) => {
                                handleFieldChange( 'cfw_ob_offer_subheading', newValue );
                            }
                        }
                    />
                </>
        }

        <TextControl
            label={ meta.cfw_ob_display_location !== 'complete_order' ? __( 'Offer Acceptance Checkbox Label', 'checkout-wc' ) : __( 'Offer Acceptance Button Label', 'checkout-wc' ) }
            help={__( 'Example: Yes! Please add this offer to my order', 'checkout-wc' )}
            value={ meta.cfw_ob_offer_language }
            onChange={
                ( newValue: string ) => {
                    handleFieldChange( 'cfw_ob_offer_language', newValue );
                }
            }
        />

        <TextareaControl
            label={__( 'Offer Description', 'checkout-wc' )}
            help={__( 'Example: Limited time offer! Get an EXCLUSIVE discount right now! Click the checkbox above to add this product to your order now.', 'checkout-wc' )}
            value={ meta.cfw_ob_offer_description }
            onChange={
                ( newValue: string ) => {
                    handleFieldChange( 'cfw_ob_offer_description', newValue );
                }
            }
        />

        <TextControl
            label={__( 'Modal Offer Rejection Link Text', 'checkout-wc' )}
            help={ (
                <>
                    <span>
                        {__( 'Displays in modal version of Order Bump, such as Place Order bumps or when the Offer Product is a variable product (as opposed to a specific variation).', 'checkout-wc' )}
                    </span>
                    <br /><br />
                    <span>
                        {meta.cfw_ob_display_location === 'complete_order' ? (
                            <>{__( 'Default if blank: No thanks, just complete my order', 'checkout-wc' )}</>
                        ) : (
                            <>{__( 'Default if blank: No thanks', 'checkout-wc' )}</>
                        )}
                    </span>
                </>
            ) }
            value={ meta.cfw_ob_offer_cancel_button_text }
            onChange={
                ( newValue: string ) => {
                    handleFieldChange( 'cfw_ob_offer_cancel_button_text', newValue );
                }
            }
        />
    </PluginDocumentSettingPanel>
);

export default withMetaboxValidation( OrderBumpsOfferLanguagePanel, getValidationRules );
